import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface PageContainerProps {
  title: string;
  children?: ReactNode;
}

export function PageContainer({ title, children }: PageContainerProps) {
  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Typography variant="h3" sx={{ mb: 2.5, fontWeight: 700, letterSpacing: '-0.02em' }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}
